import { addOrUpdateChatScript } from '../../apiClient';
import { notifications } from '@mantine/notifications';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useAddChatScript = () => {
    const entityUpdater = useEntityQueryUpdate();

    const mutation = useMutation({
        mutationKey: 'add_chat_script',
        mutationFn: (model) => {
            return addOrUpdateChatScript(model);
        },
        onSuccess: (data) => {
            entityUpdater([['chat_scripts'], ['chat_script', data.id]], data);
            notifications.show({
                title: 'Success',
                message: 'Successfully updated chat script',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useAddChatScript;
